import { createSelector } from 'reselect';

import {
    mapArrayNumberToStringValues,
    removeAllHTMLAndUnicodeSymbols,
} from '../../../helpers/helpers';
import moment from 'moment';
import { QuizReduxType, QuizSelectorType } from '../types';
import { isAuthorNull } from '../../../helpers/isAuthorNull.helpers';
import { InitdataState } from 'store/ducks/app/types';

const categories = (state: { initdata: InitdataState }) =>
    state.initdata.categories;

const tags = (state: { initdata: { tags: InitdataState } }) =>
    state.initdata.tags;

const quiz = (state: { quiz: { quiz: QuizReduxType } }) => state.quiz.quiz;

export const quizSelector = createSelector(
    [quiz, categories, tags],
    (quiz, categories, tags) => {
        let renderQuiz: QuizSelectorType = null;
        if (
            quiz &&
            Object.keys(quiz).length &&
            Object.keys(categories).length &&
            Object.keys(tags).length
        ) {
            let imgShareList : any = {};

            quiz.acf.test_result_criteria.map((e:any, index:any) => {

               imgShareList[index + 1] = e.test_result_share_img;
            })


            let type = 'quiz',
                object = {
                    id: quiz.id,
                    firstScreen: {
                        date: moment(quiz.date).format('DD.MM.YYYY'),
                        tag: mapArrayNumberToStringValues(quiz.tags, tags),
                        title: quiz.acf.test_title,
                        subtitle: quiz.acf.test_subtitle,
                        bg: quiz.acf.test_bg,
                        author: quiz.acf.test_bg_credit,
                    },
                    resultScreen: {
                        bg: quiz.acf.test_result_bg,
                        author: quiz.acf.test_result_credit,
                        resultList: quiz.acf.test_result_criteria,
                    },
                    questions: quiz.acf.test_card,
                    imgShareList: imgShareList,
                };

            renderQuiz = { ...object };
        }
        return { quiz: renderQuiz };
    }
);
